module.exports = __webpack_public_path__ + "img/money_2.7e50ab9e.png";